import Button from "~/components/button";
import styled from "@emotion/styled";

export const InlineIconButton = styled(Button)`
  height: 23px;
  width: 23px;
  min-width: unset;
  margin-top: -5px;
  opacity: 0.7;

  &.mdc-button.icon-only {
    border-bottom-width: 0;
  }
`;
